import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Route, Switch } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';
import withWidth from '@material-ui/core/withWidth';
import ErrorBoundary from 'components/ErrorBoundary';
import history from '../../../../store/history';
import { routes } from '../../../index';

class App extends Component {
  componentDidMount() {
    const { fetchInstance } = this.props;

    const domain = (process.env.NODE_ENV === 'development') ? 'rise-develop.webintra.net' : window.location.host;

    fetchInstance(domain);
    document.body.classList.add('embed');
  }

  componentWillUnmount() {
    clearInterval(this.checkLoading);
  }

  loadPhysicsLibraries = () => {
    const libraries = ['/js/createjs_1.1_min.js', '/js/zim10.js', '/js/Box2dWeb-2.1.a.3.min.js', '/js/physics.js'];

    _.forEach(libraries, (library) => {
      const src = `${window.location.origin}${library}`;
      const scriptPhysic = document.createElement('script');
      scriptPhysic.src = src;
      document.head.appendChild(scriptPhysic);
    });
  }

  render() {
    const {
      app,
    } = this.props;

    if (!app.code) {
      return false;
    }

    return (
      <ErrorBoundary>
        <ConnectedRouter history={history}>
          <Switch>
            {routes.map((route, index) => (
              <Route
                key={index}
                path={route.path}
                exact={route.exact}
                render={() => (
                  <section>
                    <route.component route={history} />
                  </section>
                )}
              />
            ))}
          </Switch>
        </ConnectedRouter>
      </ErrorBoundary>
    );
  }
}

App.propTypes = {
  fetchInstance: PropTypes.func.isRequired,
  app: PropTypes.object.isRequired,
};

export default withWidth()(App);



// WEBPACK FOOTER //
// ./src/routes/Embed/App/components/index.jsx